import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "usehooks-ts";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { TailSpin } from "react-loader-spinner";

function RedirectHandler(props) {
  const api = process.env.REACT_APP_DATABASE_URI;
  const navigate = useNavigate();
  const [authcode, setAuthCode, removeAuthCode] = useSessionStorage(
    "authToken",
    ""
  );
  const [refreshcode, setRefreshCode, removeRefreshCode] = useSessionStorage(
    "refreshToken",
    ""
  );
  const queryClient = useQueryClient();

  const getAccessCode = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("code");
  };

  const setTokens = (data, return_url) => {
    setAuthCode(data.access_token);
    setRefreshCode(data.refresh_token);
    navigate(return_url);
  };

  const getRedirectType = () => {
    const params = new URLSearchParams(window.location.search);
    const return_url = params.get("return_url");
    const code = params.get("code");
    return { isRefresh: code === "refresh", return_url: return_url };
  };

  const redirectType = getRedirectType();

  const refreshToken = async () => {
    const response = await fetch(`${api}/auth/refresh`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "refresh-token": refreshcode,
      },
    });

    if (!response.ok) {
      navigate("/login");
      throw new Error("Failed to refresh token");
    }

    const data = await response.json();
    setAuthCode(data.access_token);
    setRefreshCode(data.refresh_token);
    return data.access_token;
  };

  const fetchToken = async () => {
    const url = redirectType.isRefresh ? `${api}/auth/refresh` : `${api}/auth`;
    const headers = {
      "Content-Type": "application/json",
      ...(redirectType.isRefresh
        ? { "refresh-token": refreshcode }
        : { "temporary-access-code": getAccessCode() }),
    };

    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: headers,
    });

    if (response.status === 401 && !redirectType.isRefresh) {
      const newAuthToken = await refreshToken();
      const retryResponse = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "temporary-access-code": getAccessCode(),
          Authorization: `Bearer ${newAuthToken}`,
        },
      });
      if (!retryResponse.ok) {
        throw new Error("Network response was not ok");
      }
      return retryResponse.json();
    }

    if (!response.ok) {
      if (redirectType.isRefresh) {
        navigate("/login");
      }
      throw new Error("Network response was not ok");
    }

    return response.json();
  };

  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["authToken"],
    enabled: true,
    retry: false,
    queryFn: fetchToken,
  });

  useEffect(() => {
    props.callBack(false);
  }, [props]);

  useEffect(() => {
    if (isSuccess) {
      const returnUrl = redirectType.isRefresh
        ? redirectType.return_url
        : "/opportunities";
      setTokens(data, `/redirectProfile?return_url=${returnUrl}`);
    }
  }, [isSuccess, data, redirectType]);

  if (isPending) {
    return (
      <div className="redirect">
        <TailSpin
          visible={true}
          height="150"
          width="150"
          color="#037EF2"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }

  if (isError) {
    console.error("Fetch error:", error);
  }

  return null;
}

export default RedirectHandler;
